module.exports = __webpack_public_path__ + "img/bolt.589437a2.svg";